import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-special",
  "use": "icon-special-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-special\"><path d=\"M77.03514075 300.73135408v683.5162074c0 18.64135111 24.85513482 31.06891852 37.28270222 18.64135111L499.57243259 729.48242963c6.2137837-6.2137837 18.64135111-6.2137837 31.06891852 0l379.04080592 273.40648296c18.64135111 12.42756741 37.28270222 0 37.28270222-18.64135111v-683.5162074c0-37.28270222-31.06891852-68.35162075-62.13783703-68.35162075H139.17297778c-31.06891852 0-62.13783703 31.06891852-62.13783703 68.35162075zM909.68215703 139.17297778H114.31784297c-18.64135111 0-37.28270222-18.64135111-37.28270222-37.28270223v-49.71026963c0-24.85513482 18.64135111-37.28270222 37.28270222-37.28270222h795.36431406c18.64135111 0 37.28270222 12.42756741 37.28270222 37.28270222v49.71026963c0 18.64135111-18.64135111 37.28270222-37.28270222 37.28270223z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/special.svg
// module id = TgGA
// module chunks = 65